import type { ScenarioResult } from '@gpa-scales/shared-types';

export function ScenarioResultTable({ result }: { result: ScenarioResult }) {
  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="text-[var(--color-text-muted)]">
          <th scope="col" className="text-left">Variant</th>
          <th scope="col" className="text-right" title="GPA before the scenario is applied.">Current</th>
          <th scope="col" className="text-right" title="Estimated GPA if the scenario grades hold.">Projected</th>
          <th scope="col" className="text-right" title="Change from current to projected.">Delta</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(result.projectedGPA).map((label) => (
          <tr key={label}>
            <td className="text-[var(--color-text)]">{label}</td>
            <td className="text-right">{(result.currentGPA[label] ?? 0).toFixed(2)}</td>
            <td className="text-right font-medium">{result.projectedGPA[label].toFixed(2)}</td>
            <td className={`text-right font-medium ${(result.delta[label] ?? 0) >= 0 ? 'text-success' : 'text-error'}`}>
              {(result.delta[label] ?? 0) >= 0 ? '↑' : '↓'} {Math.abs(result.delta[label] ?? 0).toFixed(2)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
